import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

const FeaturedService = () => {
  const { home: homeData } = useSelector((state) => state?.pageContents);

  return (
    <>
      {homeData?.homejoin && (
        <div className="second-facility-area six pt-100 pb-70">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-2 col-sm-6 hide-sec"></div>
              {/* LEFT home box */}
              <div className="col-lg-4 col-sm-6">
                <div className="second-facility-item">
                  <img src={homeData.homejoin.image} alt="[]" />
                  <h3>{homeData.homejoin.title}</h3>
                  <p>{homeData.homejoin.short_description}</p>

                  <Link to="/signup" className="read-more">
                    Read More <i className="bx bx-plus"></i>
                  </Link>
                </div>
              </div>
              {/* RIGHT home box */}
              <div className="col-lg-4 col-sm-6">
                <div className="second-facility-item">
                  <img src={homeData.homejoin.image_mob} alt="[]" />
                  <h3>{homeData.homejoin.title_sc}</h3>
                  <p>{homeData.homejoin.short_description_sc}</p>
                  <Link to="/donate" className="read-more">
                    Read More <i className="bx bx-plus"></i>
                  </Link>
                </div>
              </div>

              <div className="col-lg-2 col-sm-6 hide-sec"></div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default FeaturedService;
